<template>
    <!-- Topbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-sa-topbar shadow fixed-top">
        <div class="container-fluid">
            <!--Left side Div-->
            <div class="d-flex w-13">
                <!-- Logo with notification on the left -->
<div class="dropdown switcher-wrap me-2">
    <button
        type="button"
        class="btn btn-sm border-0 company-switch-btn d-flex align-items-center gap-2 text-start"
        id="companyBranchDropdown"
        :data-bs-toggle="canOpenSwitcher ? 'dropdown' : null"
        data-bs-auto-close="outside"
        aria-expanded="false"
        :title="canOpenSwitcher ? 'Switch company / branch' : ''"
        :class="{ 'no-switch': !canOpenSwitcher }"
        @click="onSwitcherOpen"
    >
        <span class="d-flex flex-column overflow-hidden">
            <span class="company-name fw-bold color-sa-topbar">{{ companyName || 'Admin' }}</span>
            <small v-if="branchName" class="branch-name color-sa-topbar">{{ branchName }}</small>
        </span>
        <i v-if="canOpenSwitcher" class="bi bi-chevron-down ms-auto color-sa-topbar"></i>
    </button>

        <ul class="dropdown-menu animate-myFlipInX switcher-menu" aria-labelledby="companyBranchDropdown">

        <li v-if="switchingCompanyBranch">
            <span class="dropdown-item-text small"><i class="fa fa-cog fa-spin me-1"></i>Switching...</span>
        </li>

        <!-- Step 1: choose a company -->
        <template v-if="switcherStep === 'company'">
            <li>
                <h6 class="dropdown-header switcher-step-title">
                    <i class="bi bi-building me-1"></i>Step 1 of 2: Choose a company
                </h6>
            </li>
            <li v-if="userCompanies.length === 0">
                <span class="dropdown-item-text small text-muted">No companies assigned.</span>
            </li>
            <li v-for="company in userCompanies" :key="'c' + company.id">
                <a
                    href="#"
                    class="dropdown-item d-flex align-items-center justify-content-between"
                    @click.prevent="selectCompany(company)"
                >
                    <span class="d-flex align-items-center overflow-hidden">
                        <span class="menu-name" :title="company.company_name">{{ company.company_name }}</span>
                        <span v-if="company.is_platform" class="badge bg-warning text-dark platform-badge flex-shrink-0" title="Platform company">Platform</span>
                    </span>
                    <span class="d-flex align-items-center">
                        <i v-if="Number(company.id) === Number(companyId)" class="bi bi-check text-success fs-5" title="Current company"></i>
                        <i class="bi bi-chevron-right ms-2 text-muted"></i>
                    </span>
                </a>
            </li>
            <template v-if="$hasPermission('companies.view')">
                <li><hr class="dropdown-divider"></li>
                <li>
                    <a href="#" class="dropdown-item text-primary fw-semibold" @click.prevent="goToAdd('company')">
                        <i class="bi bi-plus-circle me-1"></i>Add company
                    </a>
                </li>
            </template>
        </template>

        <!-- Step 2: choose a branch of that company -->
        <template v-else>
            <!-- Only when there is more than one company to go back to -->
            <template v-if="showCompanyStep">
                <li>
                    <a href="#" class="dropdown-item small text-muted" @click.prevent="switcherStep = 'company'">
                        <i class="bi bi-arrow-left me-1"></i>Back to companies
                    </a>
                </li>
                <li><hr class="dropdown-divider"></li>
            </template>
            <!-- Only when there is more than one branch to choose from -->
            <li v-if="selectedCompanyBranches.length > 1 || showCompanyStep">
                <h6 class="dropdown-header switcher-step-title">
                    <i class="bi bi-geo-alt me-1"></i>
                    <template v-if="showCompanyStep">Step 2 of 2: </template>Choose a branch in
                    <strong>{{ selectedCompany ? selectedCompany.company_name : '' }}</strong>
                </h6>
            </li>
            <li v-if="selectedCompanyBranches.length === 0">
                <span class="dropdown-item-text small text-muted">No branches assigned.</span>
            </li>
            <li v-for="branch in selectedCompanyBranches" :key="'b' + (branch.id ?? 'all')">
                <a
                    href="#"
                    class="dropdown-item d-flex align-items-center justify-content-between"
                    :class="{ 'disabled opacity-50': switchingCompanyBranch }"
                    @click.prevent="switchCompanyBranch(branch)"
                >
                    <span class="menu-name" :title="branch.branch_name">
                        {{ branch.branch_name }}
                        <small v-if="branch.is_head_office == 1" class="ms-1">(HQ)</small>
                    </span>
                    <i
                        v-if="Number(selectedCompanyId) === Number(companyId) &&
                              (branch.is_all_branches ? branchId === null || branchId === undefined : Number(branch.id) === Number(branchId))"
                        class="bi bi-check text-success fs-5"
                        title="Current branch"
                    ></i>
                </a>
            </li>
            <template v-if="$hasPermission('companies.view')">
                <li><hr class="dropdown-divider"></li>
                <li>
                    <a href="#" class="dropdown-item text-primary fw-semibold" @click.prevent="goToAdd('branch')">
                        <i class="bi bi-plus-circle me-1"></i>Add branch to {{ selectedCompany ? selectedCompany.company_name : 'this company' }}
                    </a>
                </li>
            </template>
        </template>
    </ul>

</div>


                <!--custom-dropdown-box & it's trigger button-->
                <button
                    type="button"
                    class="btn btn-sm btn-primary dropdown-toggle aicon position-relative ms-auto flex-shrink-0 align-self-center py-2 px-2"
                    id="dropdownBtn"
                >
                    <i class="fa fa-lg fa-user text-black-50"></i>
                    <span
                        class="badge rounded-pill nt-badge position-absolute top-0 start-50 translate-right"
                        :class="{'bg-primary': totalCount === 0,'bg-danger': totalCount > 0}"
                    >
                        {{ totalCount }}
                    </span>
                </button> 
                <div class="custom-dropdown-box custom-dropdown-bg animate-myFlipInY d-none" id="customDropdown">
  <i class="fa fa-lg fa-caret-up custom-caret-up dropdown-icon"></i>

  <!-- Segmented tabs -->
  <div class="dd-tabs-wrap">
    <ul class="nav dd-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-bs-toggle="tab" href="#home" @click="openMessages">Msgs ({{ messageCount }})</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-bs-toggle="tab" href="#menu1" @click="openNotifications">Notify ({{ notificationCount }})</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-bs-toggle="tab" href="#menu2" @click="openTasks">Tasks ({{ taskCount }})</a>
      </li>
    </ul>
  </div>

  <div class="tab-content dd-body">

    <!-- MESSAGES -->
    <div class="tab-pane active" id="home">
      <div v-if="messageLoading" class="dd-empty sa-core-color"><i class="fa fa-cog fa-spin me-2"></i>Loading...</div>
      <template v-else-if="messages.length > 0">
        <div v-for="message in messages" :key="message.id" class="dd-row dd-msg" :class="{'dd-unread': message.unread}">
          <img :src="message.avatar" class="dd-avatar" alt="User" />
          <div class="dd-content">
            <div class="dd-msg-top">
              <span class="dd-msg-name sa-core-color">{{ message.name }}</span>
              <span class="dd-msg-time">{{ message.time }}</span>
            </div>
            <div class="dd-msg-subject sa-core-color">{{ message.subject }}</div>
            <div class="dd-msg-text sa-core-color">{{ message.message }}</div>
          </div>
        </div>
      </template>
      <div v-else class="dd-empty">
        <i class="fa fa-envelope-open fa-2x mb-2 opacity-50"></i>
        <div class="small">No new messages.</div>
      </div>
    </div>

    <!-- NOTIFICATIONS -->
<div class="tab-pane fade" id="menu1">
  <div v-if="notificationLoading" class="dd-empty sa-core-color"><i class="fa fa-cog fa-spin me-2"></i>Loading...</div>

  <!-- From DB -->
  <template v-else-if="notifications.length > 0">
    <div
        v-for="n in notifications"
        :key="n.id"
        class="dd-row dd-note"
        :class="'dd-note-' + (n.type || 'default').toLowerCase()"
    >
        <div class="dd-icon" :class="getNotificationTypeClass(n.type)">
            <i class="fa fa-bell"></i>
        </div>

        <div class="dd-content">
            <div class="dd-note-top">
                <div class="dd-note-text">{{ n.message }}</div>

                <!-- Accept and Reject Buttons -->
                <div
                    v-if="n.type && n.type.toLowerCase() === 'approval'"
                    class="dd-note-actions"
                >
                    <button
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="handleNotificationAction(n, 'accept')"
                    >
                        Accept
                    </button>

                    <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="handleNotificationAction(n, 'reject')"
                    >
                        Reject
                    </button>
                </div>

                <!-- Attend Event Buttons -->
                <div
                    v-if="n.type && n.type.toLowerCase() === 'attendance'"
                    class="dd-note-actions"
                >
                    <button
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="handleNotificationAction(n, 'accept')"
                    >
                        Attend
                    </button>

                    <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="handleNotificationAction(n, 'reject')"
                    >
                        No
                    </button>
                </div>

                                <!-- Renew Subscription Button -->
                <div
                    v-if="n.type && n.type.toLowerCase() === 'subscription'"
                    class="dd-note-actions"
                >
                    <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="goToSubscription"
                    >
                        Renew Now
                    </button>
                </div>

                <!-- Notification Time -->
                <span class="dd-note-time">
                    {{ formatNotificationTime(n.date_created) }}
                </span>
            </div>
        </div>
    </div>
</template>

  <!-- Dummy data (always shown after DB items, remove this block when no longer needed) -->
  <template v-if="!notificationLoading">
    <div class="dd-row dd-note dd-unread">
      <div class="dd-icon dd-ic-user"><i class="fa fa-user"></i></div>
      <div class="dd-content"><div class="dd-note-top">
        <div class="dd-note-text">2 new users just signed up! <a href="#">martin.luther</a> and <a href="#">kevin.reliey</a></div>
        <span class="dd-note-time">1 min ago...</span>
      </div></div>
    </div>

    <div class="dd-row dd-note dd-highlight">
      <div class="dd-icon dd-ic-calendar"><i class="fa fa-calendar"></i></div>
      <div class="dd-content"><div class="dd-note-top">
        <div class="dd-note-text"><a href="#"><b>Calendar</b></a>: Sadi Orlaf invites you to lunch!<br><b>When:</b> 1/3/2014 (1pm - 2pm)</div>
        <span class="dd-note-time">3 hrs ago...</span>
      </div></div>
    </div>

    <div class="dd-row dd-note">
      <div class="dd-icon dd-ic-user"><i class="fa fa-user"></i></div>
      <div class="dd-content"><div class="dd-note-top">
        <div class="dd-note-text">
          <a href="#">Sofia</a> as contact?
          <span class="dd-actions">
            <span class="dd-btn dd-btn-accept">accept</span>
            <span class="dd-btn dd-btn-reject">reject</span>
          </span>
        </div>
        <span class="dd-note-time">3 hrs ago...</span>
      </div></div>
    </div>

    <div class="dd-row dd-note">
      <div class="dd-icon dd-ic-facebook"><i class="fa fa-facebook"></i></div>
      <div class="dd-content"><div class="dd-note-top">
        <div class="dd-note-text">Facebook recived +33 unique likes</div>
        <span class="dd-note-time">4 hrs ago...</span>
      </div></div>
    </div>

    <div class="dd-row dd-note">
      <div class="dd-icon dd-ic-check"><i class="fa fa-check"></i></div>
      <div class="dd-content"><div class="dd-note-top">
        <div class="dd-note-text">2 projects were completed on time! Submitted for your approval - <a href="#">Click here</a></div>
        <span class="dd-note-time">1 day ago...</span>
      </div></div>
    </div>

    <div class="dd-row dd-note">
      <div class="dd-icon dd-ic-lock"><i class="fa fa-lock"></i></div>
      <div class="dd-content"><div class="dd-note-top">
        <div class="dd-note-text">Your password was recently updated. Please <a href="#">review</a> your security settings.</div>
        <span class="dd-note-time">2 days ago...</span>
      </div></div>
    </div>
  </template>
</div>

    <!-- TASKS -->
    <div class="tab-pane fade" id="menu2">
      <div v-if="taskLoading" class="dd-empty sa-core-color"><i class="fa fa-cog fa-spin me-2"></i>Loading...</div>
      <template v-else-if="tasks.length > 0">
  <div v-for="task in tasks" :key="task.id" class="dd-row dd-task">
    <div class="dd-task-top">
      <span class="dd-task-label" :class="'p-' + String(task.priority || task.type || 'normal').toLowerCase()">
        <i v-if="String(task.priority || '').toUpperCase() === 'PRIMARY'" class="fa fa-exclamation-triangle dd-warn"></i>
        <b v-if="task.priority">{{ task.priority }}:</b> <em>{{ task.title }}</em>
      </span>
      <span class="dd-task-pct" :class="{'text-crit': String(task.priority || '').toUpperCase() === 'CRITICAL'}">
        {{ task.progress || 0 }}%
      </span>
    </div>
    <div class="dd-progress">
      <div class="dd-progress-bar"
           :class="['p-' + String(task.priority || task.type || 'normal').toLowerCase(),
                    {striped: String(task.priority || '').toUpperCase() === 'PRIMARY'}]"
           :style="{width: (task.progress || 0) + '%'}"></div>
    </div>
    <div class="dd-task-updated">last updated on {{ task.updated || task.time }}</div>
  </div>
</template>
      <div v-else class="dd-empty">
        <i class="fa fa-check-circle fa-2x mb-2 opacity-50"></i>
        <div class="small">No pending tasks.</div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="dd-footer">
    <span>Last updated on: {{ lastUpdated }}</span>
    <button type="button" class="dd-refresh" @click="refreshAll"><i class="fa fa-refresh"></i></button>
  </div>
</div>
                <!--End custom-dropdown-box & it's trigger button-->


            </div>
            <!--End Left side Div-->

            <!-- Recent Project Dropdown - immediately opposite notification -->
            <div class="d-none d-lg-flex align-items-center ms-3">
                <div class="dropdown">
                    <button
                        class="btn btn-outline-secondary btn-sm dropdown-toggle"
                        type="button"
                        id="recentProjectDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <span class="sa-core-color">Recent Projects</span>
                    </button>
                    <ul class="dropdown-menu animate-myFlipInX" aria-labelledby="recentProjectDropdown">
                        <li><a class="dropdown-item" href="#">Project Alpha</a></li>
                        <li><a class="dropdown-item" href="#">Project Beta</a></li>
                        <li><a class="dropdown-item" href="#">Project Gamma</a></li>
                    </ul>
                </div>
            </div>
            <!-- End Recent Project Dropdown - immediately opposite notification -->
            <!-- Right-side items (Search, Theme, Profile) -->
            <div class="d-flex align-items-center ms-auto">
                <!-- Languages -->
                <div class="d-none d-lg-flex align-items-center ms-3">
                    <div class="dropdown">
                        <button
                            class="btn btn-outline-secondary btn-sm dropdown-toggle"
                            type="button"
                            id="appLanguages"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            🇺🇸 <span class="sa-core-color">English (US)</span>
                        </button>
                        <ul class="dropdown-menu animate-myFlipInX" aria-labelledby="appLanguages">
                            <li><a class="dropdown-item" href="#">🇺🇸 English (US)</a></li>
                            <li><a class="dropdown-item" href="#">🇫🇷 Francais</a></li>
                            <li><a class="dropdown-item" href="#">🇩🇪 Deutsch</a></li>
                        </ul>
                    </div>
                </div>
                <!-- End Languages -->
                <!-- Fullscreen toggle button - desktop only -->
                <button
                    class="btn btn-sm btn-outline-secondary me-2 d-none d-lg-inline"
                    id="fullscreenBtn"
                    title="Toggle Fullscreen"
                >
                    <i class="fa fa-arrows-alt sa-core-color"></i>
                </button>
                <!-- Phones: search icon that opens the search box -->
                <button
                    ref="mobileSearchBtn"
                    id="topbarSearchBtn"
                    type="button"
                    class="btn btn-sm btn-outline-secondary me-2 py-2 px-2 d-lg-none"
                    @click.stop="toggleMobileSearch"
                    :title="showMobileSearch ? 'Close search' : 'Search'"
                    :class="{ active: showMobileSearch }"
                >
                    <i class="fa sa-core-color" :class="showMobileSearch ? 'fa-times' : 'fa-search'"></i>
                </button>

                <!-- Search box: always on computers; on phones only after tapping the icon -->
                <div
                    ref="searchBox"
                    class="search-wrapper"
                    :class="showMobileSearch ? 'mobile-search-open' : 'position-relative d-none d-lg-block'"
                >
                    <input
                        ref="searchInput"
                        v-model="searchQuery"
                        type="search"
                        class="form-control form-control-sm ps-2 pe-4 search-input"
                        placeholder="Search..."
                        autocomplete="off"
                        @input="onSearchInput"
                        @focus="showSearchResults = true"
                        @keydown.down.prevent="moveSearchSelection(1)"
                        @keydown.up.prevent="moveSearchSelection(-1)"
                        @keydown.enter.prevent="openSelectedSearchResult"
                        @keydown.esc="closeSearch"
                    />
                    <i class="fa fa-search position-absolute search-icon"></i>

                    <!-- Search panel: hint first, matching pages once you type -->
                    <ul v-if="showSearchResults" class="search-results list-unstyled mb-0">
                        <!-- Nothing typed yet: hint -->
                        <li v-if="!searchQuery.trim()" class="search-empty">
                            <i class="fa fa-search me-2"></i>Type to search pages, e.g. users, payments, tags
                        </li>

                        <!-- Matching pages -->
                        <template v-else>
                            <li v-for="(page, index) in searchResults" :key="page.path">
                                <a
                                    href="#"
                                    class="search-result"
                                    :class="{ active: index === searchActiveIndex }"
                                    @click.prevent="goToPage(page)"
                                    @mouseenter="searchActiveIndex = index"
                                >
                                    <i :class="[page.icon, 'fa-fw me-2']"></i>
                                    <span class="search-result-title">{{ page.title }}</span>
                                    <small class="search-result-group ms-auto ps-2">{{ page.group }}</small>
                                </a>
                            </li>
                            <li v-if="!searchResults.length" class="search-empty">
                                No pages found for "{{ searchQuery.trim() }}"
                            </li>
                        </template>
                    </ul>
                </div>
                <button
                    class="btn btn-sm btn-outline-secondary me-2 py-2 px-2 py-lg-1"
                    data-bs-toggle="modal"
                    data-bs-target="#logOutModal"
                    id="topbarLogoutBtn"
                >
                    <i class="fa fa-sign-out sa-core-color"></i>
                </button>
                <!--sidebarControls-->
                <div id="sidebarControls">
                    <!-- Sidebar collapse button Custom made for Desktop at far right-->
                    <button
                        class="btn btn-sm btn-outline-secondary me-2 d-none d-lg-inline"
                        id="sidebarCollapseBtn"
                        title="Toggle Sidebar"
                    >
                        <i class="fa fa-bars sa-core-color"></i>
                    </button>
                    <!--End Sidebar collapse button Custom made for Desktop at far right--->
                    <!-- Sidebar toggle for mobile Custom made-->
                    <button
                        class="navbar-toggler-custom py-1 px-2 d-lg-none"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#sidebar"
                        aria-controls="sidebar"
                    >
                        <!--☰-->
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <!-- End Sidebar toggle for mobile Custom made -->
                </div>
                <!--End sidebarControls-->
                <!-- userMenuWhenSwitchedToTop -->
                <div class="userMenuWhenSwitchedToTop">
                    <!--Pasted inside here-->
                </div>
                <!--End userMenuWhenSwitchedToTop-->
                <div id="navbarTogglerControls">
                    <!--Bootstrap navbar-toggler-->
                    <button
                        class="py-1 px-2 d-lg-none navbar-toggler-custom"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsibleTopMenu"
                        aria-controls="collapsibleTopMenu"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <!--End Bootstrap navbar-toggler-->
                </div>
            </div>
            <!-- End Right-side items (Search, Theme, Profile) -->
        </div>
    </nav>
    <!-- End Topbar -->
    <!-- Top Horizontal Menu -->
    <nav
        id="topHorizontalMenu"
        class="navbar navbar-expand-xl navbar-dark bg-sa-tophmenu d-none slim-top top-horizontal-menu"
    >
        <!--<div class="container-fluid">-->
        <!--<a class="navbar-brand" href="#">Admin Dashboard</a>-->
        <div class="collapse navbar-collapse" id="collapsibleTopMenu">
            <ul class="navbar-nav me-auto mb-2 mb-sm-0" id="horizontalMenuList">
                <!-- Cloned sidebar items will go here -->
            </ul>
        </div>
    </nav>
    <!--End topHorizontalMenu-->
</template>

<script>
    import axios from "axios";
import searchPages from "@/utils/searchPages.js";
    import emitter from "../../main.js";

    export default {
        data() {
            return {
                messageCount: 0,
                notificationCount: 0,
                taskCount: 0,

                messages: [],
                tasks: [],
                notifications: [],

                notificationInterval: null,

                notificationLoading: false,
                messageLoading: false,
                taskLoading: false,

                // Company & branch switcher
                userCompanies: [],
                selectedCompanyId: null,
                switchingCompanyBranch: false,
                switcherStep: "company", // "company" or "branch"

                // Phones: the search box opened from the search icon
                showMobileSearch: false,

                // Page finder (topbar search)
                searchQuery: "",
                showSearchResults: false,
                searchActiveIndex: 0,
                searchPages: searchPages,
            };
        },
        async created() {
            if (!this.isLoggedIn) {
                return;
            }
            this.openMessages();
            this.fetchNotifications();
            this.getUserCompanyBranchAssignments();
            this.notificationInterval = setInterval(() => {
                this.fetchNotifications();
            }, this.$notificationRefreshInterval); // variable found in main.js
        },
        mounted() {
            // Phones: a click outside the search box hides it
            document.addEventListener("click", this.onDocumentClick);
        },
        beforeUnmount() {
            if (this.notificationInterval) {
                clearInterval(this.notificationInterval);
                this.notificationInterval = null;
            }
            document.removeEventListener("click", this.onDocumentClick);
        },
        computed: {
            isLoggedIn() {
                return this.$store.state.isLoggedIn;
            },
            companyName() {
                return this.$store.state.company_name;
            },
            isPlatform() {
                return this.$store.state.is_platform;
            },
            branchName() {
                return this.$store.state.branch_name;
            },
            totalCount() {
                return this.messageCount + this.notificationCount + this.taskCount;
            },
            // Pages the user may open that match every word typed (max 8)
            searchResults() {
                const words = this.searchQuery.trim().toLowerCase().split(/\s+/).filter(Boolean);
                if (!words.length) return [];

                return this.searchPages
                    .filter((page) => !page.permission || this.$hasPermission(page.permission))
                    .filter((page) => !page.platformOnly || this.$store.state.is_platform)
                    .filter((page) => {
                        const text = `${page.title} ${page.group} ${page.keywords}`.toLowerCase();
                        return words.every((word) => text.includes(word));
                    })
                    .slice(0, 8);
            },
            companyId() {
                return this.$store.state.company_id;
            },
            branchId() {
                return this.$store.state.branch_id;
            },
            selectedCompany() {
                return this.userCompanies.find((c) => Number(c.id) === Number(this.selectedCompanyId)) || null;
            },
            hasManyCompanies() {
                return this.userCompanies.length > 1;
            },
            // Show the company list when there is a choice, or when the user can add companies
            showCompanyStep() {
                return this.hasManyCompanies || this.$hasPermission('companies.view');
            },
            // Open the dropdown only if there is something to choose or add
            canOpenSwitcher() {
                if (this.$hasPermission('companies.view') || this.hasManyCompanies) {
                    return true;
                }
                const onlyCompany = this.userCompanies[0];
                return !!onlyCompany && (onlyCompany.branches || []).length > 1;
            },
            // Branches of the chosen company; the owner also gets "All Branches"
            selectedCompanyBranches() {
                if (!this.selectedCompany) {
                    return [];
                }

                const branches = this.selectedCompany.branches || [];

                if (Number(this.selectedCompany.is_company_owner) === 1 && branches.length > 1) {
                    return [{ id: null, branch_name: "All Branches", is_all_branches: true }, ...branches];
                }

                return branches;
            },
        },
        methods: {
            /* ---------- Search box on phones ---------- */
            // Search icon: open the box (cursor in it), or close it
            toggleMobileSearch() {
                this.showMobileSearch = !this.showMobileSearch;
                this.showSearchResults = this.showMobileSearch;
                if (this.showMobileSearch) {
                    this.$nextTick(() => this.$refs.searchInput?.focus());
                }
            },
            // Any click outside the box (and not on the icon) hides the results, and the box on phones
            onDocumentClick(event) {
                const box = this.$refs.searchBox;
                const icon = this.$refs.mobileSearchBtn;
                if (box?.contains(event.target) || icon?.contains(event.target)) return;
                this.showSearchResults = false;
                this.showMobileSearch = false;
            },
            // Typing: show the list from the top
            onSearchInput() {
                this.showSearchResults = true;
                this.searchActiveIndex = 0;
            },
            // ↑ / ↓ through the list
            moveSearchSelection(step) {
                const count = this.searchResults.length;
                if (!count) return;
                this.showSearchResults = true;
                this.searchActiveIndex = (this.searchActiveIndex + step + count) % count;
            },
            // Enter: open the highlighted page
            openSelectedSearchResult() {
                const page = this.searchResults[this.searchActiveIndex];
                if (page) this.goToPage(page);
            },
            goToPage(page) {
                this.closeSearch();
                this.searchQuery = "";
                this.$refs.searchInput?.blur();
                this.$router.push(page.path);
            },
            // Esc / after opening a page: hide the list (and the box on phones)
            closeSearch() {
                this.showSearchResults = false;
                this.showMobileSearch = false;
            },

            /* ---------- Company & branch switcher ---------- */
            onSwitcherOpen() {
                // Start on the active company, and refresh the list (new companies/branches)
                this.selectedCompanyId = this.companyId;
                this.switcherStep = this.showCompanyStep ? "company" : "branch";
                this.getUserCompanyBranchAssignments();
            },
            async getUserCompanyBranchAssignments() {
                try {
                    const formData = new FormData();
                    formData.append("action", "getUserCompanyBranchAssignments");

                    const response = await axios.post("/auth/api_auth.php", formData, this.$handleConfig());

                    if (response.data.status === "success") {
                        this.userCompanies = response.data.results.companies || [];
                        // Decide the step from the fresh list (a company may have just been added)
                        this.switcherStep = this.showCompanyStep ? "company" : "branch";
                        if (!this.selectedCompanyId) {
                            this.selectedCompanyId = response.data.results.active_company_id || this.companyId;
                        }
                    } else {
                        console.error(response.data.message || "Unable to load companies and branches.");
                    }
                } catch (error) {
                    console.error("Error loading company and branch assignments:", error);
                }
            },
            selectCompany(company) {
                this.selectedCompanyId = Number(company.id);

                // Only one branch: switch straight away (unless the user can add branches)
                if (this.selectedCompanyBranches.length === 1 && !this.$hasPermission('companies.view')) {
                    this.switchCompanyBranch(this.selectedCompanyBranches[0]);
                    return;
                }

                this.switcherStep = "branch";
            },
            // Opens the Companies / Branches page with its Add form open
            goToAdd(type) {
                document.getElementById("companyBranchDropdown")?.click(); // close the dropdown

                if (type === "company") {
                    this.$router.push({ path: "/settings/companies/", query: { add: 1 } });
                } else {
                    this.$router.push({ path: "/settings/branches/", query: { add: 1, company: this.selectedCompanyId } });
                }
            },
            async switchCompanyBranch(branch) {
                if (this.switchingCompanyBranch) {
                    return;
                }

                const companyId = Number(this.selectedCompanyId);
                const isAllBranches = branch.is_all_branches === true;
                const branchId = isAllBranches ? null : Number(branch.id);

                if (!companyId || (!isAllBranches && !branchId)) {
                    return;
                }

                // Already active: nothing to do
                if (
                    Number(this.companyId) === companyId &&
                    (isAllBranches ? this.branchId === null || this.branchId === undefined : Number(this.branchId) === branchId)
                ) {
                    return;
                }

                this.switchingCompanyBranch = true;

                try {
                    const formData = new FormData();
                    formData.append("action", "switchCompanyBranch");
                    formData.append("company_id", companyId);
                    if (!isAllBranches) {
                        formData.append("branch_id", branchId);
                    }

                    const response = await axios.post("/auth/api_auth.php", formData, this.$handleConfig());

                    if (response.data.status === "success") {
                        const results = response.data.results;

                        // New token carries the new company/branch
                        localStorage.setItem("jwt", results.token);

                        this.$store.commit("setUserDetails", {
                            user: {
                                company_id: results.company_id,
                                company_name: results.company_name,
                                branch_id: isAllBranches ? null : Number(results.branch_id),
                                branch_name: isAllBranches ? "All Branches" : results.branch_name,
                            },
                        });

                        // Close the dropdown
                        document.getElementById("companyBranchDropdown")?.click();

                        sessionStorage.setItem("switching_company_branch", "Switching Company & Branch...");

                        if (this.$route.path === "/dashboard" || this.$route.path === "/dashboard/") {
                            emitter.emit("companyBranchSwitched");
                        } else {
                            await this.$router.push("/dashboard");
                        }
                    } else {
                        console.error(response.data.message || "Unable to switch company and branch.");
                    }
                } catch (error) {
                    console.error("Error switching company and branch:", error);
                } finally {
                    this.switchingCompanyBranch = false;
                }
            },

            goToSubscription() {
                // Close the dropdown, then open the subscription page
                document.getElementById("customDropdown")?.classList.add("d-none");
                this.$router.push("/profile/my-subscription/");
            },
            openMessages() {
                this.messageLoading = true;

                // Simulate loading from backend
                setTimeout(() => {
                    this.messages = [
                        {
                            id: 1,
                            name: "John Doe",
                            avatar: "/img/sunny.png",
                            message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit.",
                            time: "2 minutes ago",
                        },
                        {
                            id: 2,
                            name: "Jane Smith",
                            avatar: "/img/sunny.png",
                            message: "The monthly financial report is ready for review.",
                            time: "15 minutes ago",
                        },
                        {
                            id: 3,
                            name: "Peter Kamau",
                            avatar: "/img/sunny.png",
                            message: "Please check the latest customer request.",
                            time: "1 hour ago",
                        },
                    ];

                    this.messageCount = this.messages.length;

                    this.messageLoading = false;
                }, 800);
            },
            openNotifications() {
                this.notificationLoading = true;

                let url = `/notifications/api_notifications.php?action=fetchNotifications`;

                axios
                    .get(url, this.$handleConfig())
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.notificationCount = response.data.results.notificationCount;

                            this.notifications = response.data.results.notifications;

                            // Mark them as read after loading them
                            this.markNotificationsAsRead();
                        } else {
                            if (
                                response.data?.code === "JWT_EXPIRED" ||
                                response.data?.code === "CSRF_INVALID" ||
                                response.data?.code === "AUTH_REQUIRED"
                            ) {
                                this.$forceLogOut("danger", response.data.message);
                                return;
                            }

                            console.error(response.data.message);
                        }
                    })
                    .catch((error) => {
                        if (error.message === "Network Error") {
                            console.error("No internet connection.");
                        } else {
                            console.error("Something went wrong fetching notifications.", error);
                        }
                    })
                    .finally(() => {
                        this.notificationLoading = false;
                    });
            },
            openTasks() {
                this.taskLoading = true;

                // Simulate loading from backend
                setTimeout(() => {
                    this.tasks = [
                        {
                            id: 1,
                            title: "Review pending invoices",
                            description: "Check and approve outstanding invoices.",
                            type: "warning",
                            time: "10 minutes ago",
                        },
                        {
                            id: 2,
                            title: "Complete monthly report",
                            description: "Prepare the monthly management report.",
                            type: "info",
                            time: "1 hour ago",
                        },
                    ];

                    this.taskCount = this.tasks.length;

                    this.taskLoading = false;
                }, 800);
            },
            getTaskTypeClass(type) {
                const classes = {
                    success: "bg-success",
                    info: "bg-info",
                    warning: "bg-warning",
                    error: "bg-danger",
                    reminder: "bg-primary",
                };

                return classes[type] || "bg-secondary";
            },
            fetchNotifications() {
                // Polling: only the unread count (light). The list loads when the tab is opened.
                if (!this.isLoggedIn) {
                    return;
                }

                let url = `/notifications/api_notifications.php?action=fetchNotificationCount`;

                axios
                    .get(url, this.$handleConfig())
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.notificationCount = response.data.results.notificationCount;
                            this.lastUpdated = new Date().toLocaleTimeString();
                        } else {
                            if (
                                response.data?.code === "JWT_EXPIRED" ||
                                response.data?.code === "CSRF_INVALID" ||
                                response.data?.code === "AUTH_REQUIRED"
                            ) {
                                this.$forceLogOut("danger", response.data.message);
                                return;
                            }

                            console.error(response.data.message);
                        }
                    })
                    .catch((error) => {
                        if (error.message === "Network Error") {
                            console.error("No internet connection.");
                        } else {
                            console.error("Something went wrong fetching notifications.", error);
                        }
                    });
            },
            refreshAll() {
                this.fetchNotifications();
                this.openNotifications();
            },
            formatNotificationTime(date) {
                if (!date) {
                    return "";
                }

                // Server times are UTC: add "Z" so the browser converts to local time
                const created = new Date(date.replace(" ", "T") + "Z");
                const now = new Date();

                const seconds = Math.floor((now - created) / 1000);

                if (seconds < 60) {
                    return "Just now";
                }

                const minutes = Math.floor(seconds / 60);

                if (minutes < 60) {
                    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
                }

                const hours = Math.floor(minutes / 60);

                if (hours < 24) {
                    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
                }

                const days = Math.floor(hours / 24);

                if (days < 7) {
                    return `${days} day${days === 1 ? "" : "s"} ago`;
                }

                const weeks = Math.floor(days / 7);

                if (weeks < 4) {
                    return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
                }

                const months = Math.floor(days / 30);

                if (months < 12) {
                    return `${months} month${months === 1 ? "" : "s"} ago`;
                }

                const years = Math.floor(days / 365);

                return `${years} year${years === 1 ? "" : "s"} ago`;
            },
            getNotificationTypeClass(type) {
                const classes = {
                    success: "bg-success",
                    info: "bg-info",
                    warning: "bg-warning",
                    error: "bg-danger",
                    danger: "bg-danger",
                    reminder: "bg-primary",
                    subscription: "bg-warning",
                };

                return classes[type] || "bg-secondary";
            },
            markNotificationsAsRead() {
                /*
   if (this.notificationCount === 0) {
      return;
   }*/

                const formData = new FormData();
                formData.append("action", "markNotificationsAsRead");

                axios
                    .post("/notifications/api_notifications.php", formData, this.$handleConfig())
                    .then((response) => {                      
                        if (response.data.status === "success") {
                            // Reset notification count
                            this.notificationCount = 0;

                            // Notifications have now been read
                            this.notifications.forEach((notification) => {
                                notification.is_read = 1;
                            });
                        } else {
                            if (
                                response.data?.code === "JWT_EXPIRED" ||
                                response.data?.code === "CSRF_INVALID" ||
                                response.data?.code === "AUTH_REQUIRED"
                            ) {
                                this.$forceLogOut("danger", response.data.message);
                                return;
                            }

                            console.error(response.data.message);
                        }
                    })
                    .catch((error) => {
                        if (error.message === "Network Error") {
                            console.error("No internet connection.");
                        } else {
                            console.error("Something went wrong marking notifications as read.");
                        }
                    });
            },
        },
    };
</script>
